import { render, staticRenderFns } from "./patentDetail.vue?vue&type=template&id=59161aa0&scoped=true"
import script from "./patentDetail.vue?vue&type=script&lang=js"
export * from "./patentDetail.vue?vue&type=script&lang=js"
import style0 from "./patentDetail.vue?vue&type=style&index=0&id=59161aa0&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59161aa0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59161aa0')) {
      api.createRecord('59161aa0', component.options)
    } else {
      api.reload('59161aa0', component.options)
    }
    module.hot.accept("./patentDetail.vue?vue&type=template&id=59161aa0&scoped=true", function () {
      api.rerender('59161aa0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/details/patentDetail.vue"
export default component.exports